import ApiAuth from '@/services/settings/ApiAuth';

const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1);
    n -= 1; // to make eslint happy
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  getFiles(dir, type) {
    return ApiAuth().post(`/files/${dir}/${type}`);
  },
  uploadFile(base64File, dir, type, name) {
    // put file into form data
    const file = dataURLtoFile(base64File);
    const formData = new FormData()
    formData.append('data', file, name);

    return ApiAuth().post(`/files/upload/${dir}/${type}?name=${name}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  },
  uploadRawFile(file, dir, type, name) {
    const formData = new FormData()
    formData.append('data', file, name);

    return ApiAuth().post(`/files/upload/${dir}/${type}?name=${name}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  },
  confirmUploadFile(dir, type, name, hash) {
    return ApiAuth().post(`/files/upload/${dir}/${type}?name=${name}&hash=${hash}`);
  },
  uploadRawFileWithRewrite(file, dir, type, name) {
    // put file into form data
    const formData = new FormData()
    formData.append('data', file, name);

    return ApiAuth().post(`/files/upload/${dir}/${type}?name=${name}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }).catch(e => {
      if (e.response) {
        const { data, status } = e.response;

        if (status === 409 && data && data.Hash) {
          return ApiAuth().post(`/files/upload/${dir}/${type}?name=${name}&hash=${data.Hash}`);
        }
        return Promise.reject(e);
      }
      return Promise.reject(e);
    });
  },
  deleteFile(dir, name) {
    return ApiAuth().delete(`/files/${dir}?name=${name}`);
  },
  createHtml(html, name) {
    const preparedHtml = html.replace('</head>', `
      <style>
        .cm-web-version-el--no-display {
          display: none;
        }
      </style>
    </head>`);

    const blob = new Blob([preparedHtml], {type: 'text/html'});
    let reader = new FileReader();
    reader.readAsDataURL(blob); // конвертирует Blob в base64 и вызывает onload

    reader.onload = function() {
      const file = dataURLtoFile(reader.result);
      const formData = new FormData()
      formData.append('data', file, name);

      return ApiAuth().post(`/files/upload/html/html?name=${name}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).catch(e => {
        if (e.response) {
          const { data, status } = e.response;

          if (status === 409 && data && data.Hash) {
            return ApiAuth().post(`/files/upload/html/html?name=${name}&hash=${data.Hash}`);
          }
        }
      });
    };
  }
};
